/**
 * Asynchronously loads the component for MySchool
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null
});
